export default __webpack_public_path__ + "static/october-swimmer-a1485cefd7b444c2e3624664421318ce.png";